<template>
  <div>
    <div>
      <SideMenubar />
    </div>

    <v-main>
      <div>
        <router-view />
      </div>
    </v-main>
  </div>
</template>

<script>
import SideMenubar from './SideBar.vue';

export default {
  components: {
    SideMenubar,
  },
}
</script>
